// @flow
import React, { type Node } from 'react';
import isEmpty from 'ramda/es/isEmpty';
import { useTranslation } from 'react-i18next';

import Loading from 'app/common/components/Loader';
import EmptyWarn from 'app/common/layouts/EmptyWarn';

import ProductListTable from './ProductListTable';
import useProductListDelayed from './useProductListDelayed';
import { statuses, type Status } from '../../../dataTypes/orderRequests/statuses';

import styles from './ProductList.module.scss';;


type Props = {
  className?: string,
  customerId: string,
  orderRequestId: string,
  footerContent: ?Node,
  status: ?Status,
}

const ProductList = ({ className, customerId, orderRequestId, footerContent, status }: Props): Node => {
  const [items, loading] = useProductListDelayed({ customerId, orderRequestId });
  const nothing = isEmpty(items);
  const { t } = useTranslation('cafeteria');

  const emptyText = (
    status === statuses.WaitingForSpend
      ? t('order_request_sales_table_waiting_for_spend_empty', 'Данные  будут доступны после проведения заявки')
      : t('order_request_sales_table_empty', 'Нет данных')
  );

  return (
    <div className={className}>
      {loading
        && <Loading className={styles.loading} />}

      {!loading
        && nothing
        && <EmptyWarn>{emptyText}</EmptyWarn>}

      {!loading
        && !nothing
        && <ProductListTable items={items} />}

      {footerContent}
    </div>
  );
};

export default ProductList;
